import { type ReactNode } from 'react';
import { Megaphone, X } from 'lucide-react';
import { UserAvatar } from './UserAvatar';
import './notice-card.css';

/** Shared visual shell for arrivals; it never blocks or pauses the game. */
export function NoticeCard({
  name,
  meta,
  avatar,
  announcement,
  children,
  actions,
  onClose,
  className = '',
}: {
  name: string;
  meta: string;
  avatar?: string;
  announcement?: boolean;
  children: ReactNode;
  actions?: ReactNode;
  onClose: () => void;
  className?: string;
}) {
  return (
    <aside className={`notice-card ${className}`} aria-label={meta}>
      <button className="notice-close" aria-label="收起提醒" onClick={onClose}>
        <X size={18} />
      </button>
      <header className="notice-heading">
        {announcement ? (
          <span className="notice-emblem">
            <Megaphone size={23} />
          </span>
        ) : (
          <UserAvatar src={avatar || ''} size={42} />
        )}
        <div>
          <strong>{name}</strong>
          <small>{meta}</small>
        </div>
      </header>
      <div className="notice-copy" role="status" aria-live="polite">
        {children}
      </div>
      {actions && <footer className="notice-actions">{actions}</footer>}
    </aside>
  );
}
